// extracted by mini-css-extract-plugin
export default {"card":"Card_card__LBaKG","card_name":"Card_card_name__MEc6d","image_container":"Card_image_container__-5PRa"};